module.exports = __webpack_public_path__ + "static/media/41.6b211664.png";